import type {PreSendCollector} from './index';
import {getProduct} from '../ask-ai-store';


export const askAISourceCollector: PreSendCollector = {
  id: 'askai-source',
  collect: async () => {
    const product = getProduct();
    if (!product) {
      return;
    }
    return {product};
  },
};
